import { FlaskConical } from 'lucide-react';
import { isProductionRuntime } from '@/shared/mfaBypassAllowlist';

/**
 * ENT-1141 / parent ENT-1122 — non-prod MFA testing hint.
 *
 * Renders nothing in production builds or on production hostnames. In every
 * allowed non-production runtime, it points testers at the BotBuddy widget's
 * 2FA chip. TOTP secrets must stay out of Vite-exposed browser bundles:
 * local uses `public/.botbuddy-totp.json`, while preview/staging use BotBuddy's
 * server-side `/widget/totp-code` path.
 *
 * This does NOT bypass `supabase.auth.mfa.verify`. It only reduces tester
 * context switching for the real MFA challenge.
 */
export function NonProdMfaCodeBanner() {
  const env = import.meta.env.VITE_SENTRY_ENVIRONMENT;
  const hostname = typeof window === 'undefined' ? undefined : window.location.hostname;

  if (isProductionRuntime(env, hostname)) return null;

  return (
    <div
      data-testid="nonprod-mfa-code-banner-hint"
      className="mb-4 flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:border-amber-700/60 dark:bg-amber-950/30 dark:text-amber-200"
    >
      <FlaskConical className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>Non-prod test mode — use the BotBuddy widget&apos;s 2FA chip for the current code.</span>
    </div>
  );
}
